


























































































































































































































































































































































































































































































/* 
  getSelectNum 评卷员数量/选拔数量
  getParam 获取评卷教师选拔页面参数
  getMarkTchSelect 获取评卷教师选拔分页列表
  autoSelect 自动选拔
  confirmOrCancelSelect 确定或取消选拔
  editParam 配置参数
  getSelectParamVo 根据科目获取选拔参数信息
*/
import { Vue, Component } from "vue-property-decorator";
import { blurTeacherAge,validateTeacherAge, validateMaxHundredTwoPoint, validateTwoDecimalPoint} from '@/utils/regxCustom'
//引入接口调用函数
import {
  getSelectNum,
  getParam,
  getMarkTchSelect,
  autoSelect,
  confirmOrCancelSelect,
  editParam,
  getSelectParamVo
} from "../../../api/markingTeacherChoose";
//引入导入、导出、下载的处理函数
import importAndExportMixin from "../../../mixins/importAndExport";
// 引入表单校验
import { ruleNormal, rulePattern } from "../../../utils/common";
import { Form as ElForm } from "element-ui";
import { getSchoolByDistrict } from "../../../api/schoolManage";
@Component({
  name: "markingTeacherChoose",
  mixins: [importAndExportMixin]
})
export default class extends Vue {
  private subjectId: string = ""; //科目id
  private teachingAge: number | null = null; //教龄（大于）
  private projectLabel: string = ""; //项目展示标签
  private showTableLoading: boolean = false; //是否显示列表loading
  private tableData: object[] = []; //列表数据
  private pageNo: number = 1; //当前页码
  private pageSize: number = 10; //当前条目
  private total: number = 0; //总条数
  private chooseIdArray: string[] = []; //勾选的数据id集合
  private chooseRowArray: object[] = []; //勾选的数据行 row 集合
  private showParamsDialog: boolean = false; //是否显示"自动选拔参数配置"弹窗
  private showAutoChooeseDialog: boolean = false; //是否显示"自动选拔"弹窗
  private paramsForm: object = {}; //"自动选拔参数配置"弹窗的数据
  private autoChooeseForm: object = {}; //"自动选拔"弹窗的数据
  private orderObj: any = { orderBy: "", order: "" }; //当前排序的对象 { 排序字段, 升序/降序 }
  //页面参数
  private markStatistic: object = { total: "", choosed: "" }; //总人数和已选拔人数统计
  private projects: object[] = []; //项目数组
  private subjects: object[] = []; //科目
  private professionals: object[] = []; //职称
  private urbanDistricts: object[] = []; //市县
  private districtSchools: object[] = []; //当前市县下的单位列表
  private genders: object[] = []; //性别
  private grades: object[] = []; //任教年级
  private fullscreenLoading: boolean = false; //是否显示spin
  private tableHeight: number = 0; //获取窗口高度
  private inputCheck: boolean = true; // 查询格式校验是否通过
  private showAdvancedSearch: boolean = false; //是否显示高级筛选
  private showEmployJumpDialog: boolean = false; //是否显示聘用跳转对话框
  private selectedCount: number = 0; //本次选拔的教师数量
  public $refs!: {
    table: HTMLFormElement;
    editForm: ElForm;
  };
  // 自动选拔参数配置 必填格式校验
  private editFormRules: object = {
    paramRecommend: [ruleNormal("必填项")],
    paramExcellentTeacher: [ruleNormal("必填项")],
    paramProfessionalId: [ruleNormal("必填项")],
    paramTeachingAge: [ruleNormal("必填项"), { validator: validateTeacherAge },{ validator: blurTeacherAge, trigger: "blur" }],
    paramMarkingVolume: [ruleNormal("必填项"), { validator: validateTwoDecimalPoint }],
    paramInefficiency: [ruleNormal("请输入0-100的值"),  { validator: validateMaxHundredTwoPoint }]
  };

  private formRules: object = {
    teachingAge: [
       { validator: validateTeacherAge },
       { validator: blurTeacherAge, trigger: "blur" }
      ],
    markingVolume: [{ validator: validateTwoDecimalPoint }],
    inefficiency: [{ validator: validateMaxHundredTwoPoint }]
  }
  private searchForm: object = {}

  // 根据市县过滤单位列表
  get filteredSchools(): object[] {
    if (!this.searchForm['districtId']) {
      return this.districtSchools;
    }
    return this.districtSchools;
  }

  // 市县变更：清空单位选择，加载对应市县的单位列表
  private async handleDistrictChange(val: string) {
    this.searchForm['schoolId'] = '';
    if (val) {
      try {
        let res = await getSchoolByDistrict(val);
        this.districtSchools = res.data;
      } catch (error) {
        this.districtSchools = [];
      }
    } else {
      this.districtSchools = [];
    }
    this.searchHandle();
  }

  created() {
    //初始化data数据
    this.initDta();
    //获取评卷员总人数及已选拔人数
    this.getStatistics();
    //获取页面参数
    this.getParams();
    //获取列表
    this.getData();
  }

  mounted() {
    setTimeout(() => {
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 80;
      if (this.tableHeight < 300) { this.tableHeight = 300; }
    }, 100);
  }

  initDta() {
    const { projectLabel, projectId } = this.$route.query;
    if (projectLabel && projectId) {
      this.searchForm = {projectId: projectId || ""};
      this.projectLabel = projectLabel as string;
    }
  }

  //获取评卷员总人数及已选拔人数
  private async getStatistics(value?) {
    let res = await getSelectNum(value || "");
    this.markStatistic = res.data;
  }

  //获取页面参数
  private async getParams() {
    try {
      let res = await getParam();
      this.projects = res.data.projects;
      this.subjects = res.data.subjects;
      this.professionals = res.data.professionals;
      this.urbanDistricts = res.data.urbanDistricts;
      this.genders = res.data.genders;
      this.grades = res.data.grades;
    } catch (error) {
      // this.$message.error(error || "获取数据失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  // 校验教龄、评卷量、无效率 只能输入正整数
  private textCheck(e, reg) {
    let boolean = new RegExp(reg).test(e.target.value);
    if (!boolean && e.target.value != "") {
      //不满足条件，提醒并获取焦点
      this.$message.warning("查询条件有误");
      e.target.focus();
      e.target.style = "border-color:#F56C6C;";
      this.inputCheck = false;
    } else {
      e.target.style = "";
      this.inputCheck = true;
    }
  }

  //getData和exportHandle的请求参数
  private getRequestParams() {
    let params = {
      current: this.pageNo, //当前页
      projectId: this.searchForm['projectId'], //项目id
      markingInefficiency: this.searchForm['inefficiency'], //无效率
      markingWorkload:  this.searchForm['markingVolume'], //工作量/评卷量
      otherinfoIsExcellentTeacher: this.searchForm['isExcellent'], //是否优秀教师 0:是 1:否
      otherinfoIsRecommend: this.searchForm['recommend'], //是否重点推荐 0:是 1:否
      otherinfoSubjectId: this.searchForm['subjectId'], //科目id
      selectionState: this.searchForm['chooseStatus'], //选拔状态 0:未选 1:已选
      size: this.pageSize, //记录数
      teacherName: this.searchForm['teacherName'], //教师姓名
      otherinfoLastMarkingTimes: this.searchForm['otherinfoLastMarkingTimes'], //最近三年参加高考评卷次数
      otherinfoHaveRelatives: this.searchForm['otherinfoHaveRelatives'], //是否近亲或利害关系人高考
      otherinfoRecommendRole: this.searchForm['otherinfoRecommendRole'], //聘用状推荐岗位态
      teacherProfessionalId: this.searchForm['professionalId'], //职称id
      teacherTeachingAge: this.searchForm['teachingAge'], //教龄
      districtId: this.searchForm['districtId'], //市县
      genderId: this.searchForm['genderId'], //性别
      gradeId: this.searchForm['gradeId'], //任教年龄
      schoolId: this.searchForm['schoolId'], //所属单位ID
      teacherPhone: this.searchForm['teacherPhone'], //手机号
    };
    if (this.orderObj.orderBy) {
      //排序字段
      params[this.orderObj.orderBy] = this.orderObj.order;
    }
    return params;
  }

  //获取列表数据
  private async getData() {
    this.showTableLoading = true;
    if (this.inputCheck) {
      //通过查询校验后才能请求数据
      try {
        let res = await getMarkTchSelect(this.getRequestParams());
        this.showTableLoading = false;
        this.tableData = res.data.records;
        this.total = res.data.total;
      } catch (error) {
        this.showTableLoading = false;
        // this.$message.error(error || "获取数据失败");
        this[`$message`]({
          type: "error",
          message: error!.mesg ? error!.mesg : error
        });
      }
    }
  }

  // 根据分页计算页码
  private indexMethod(index) {
    return index + 1 + (this.pageNo - 1) * this.pageSize;
  }

  // 参数配置弹框中 选择科目请求数据自动填充其他表格
  private async getSelectProjectData(subjectId) {
    if (subjectId) {
      let res = await getSelectParamVo({ subjectId });
      this.paramsForm = res.data;
    }
  }

  // 项目下拉框搜索
  private async projectIdSearch(val) {
      //获取评卷员总人数及已选拔人数
      await this.getStatistics(val);
      //获取列表
      this.searchHandle();
  }
  //搜索查询
  private async searchHandle() {
     let valid = await this.$refs['searchForm'].validate();
     if(valid) {
       this.pageNo = 1;
       this.getData();
    }
  }

  // 重置搜索条件
  private resetSearch() {
    (this.$refs['searchForm'] as ElForm).resetFields();
    this.searchForm['schoolId'] = '';
    this.searchForm['teacherName'] = '';
    this.searchForm['teacherPhone'] = '';
    this.districtSchools = [];
    this.pageNo = 1;
    this.getData();
  }

  //勾选处理
  private selectChangeHandle(v: object[]) {
    this.chooseIdArray = v.map((item: any) => {
      return item.teacherId;
    });
    // 表格选中每行的数据集合 -- 可以解构 ...v ，但是顺序会改变
    this.chooseRowArray = v;
  }

  //确认选拔、取消选拔处理
  private async chooseHandle(v) {
    // if (!this.searchForm['subjectId']) {
    //   this.$message.warning("请选择科目！");
    //   return;
    // }
    if (this.chooseRowArray.length <= 0) {
      this.$message.warning("请先勾选！");
      return;
    }
    if (v === 1 || v === 0) {
      try {
        await this.$confirm(
          "若当前为已选拔/已聘用等状态，需先在「评卷聘用管理」中作废聘用或完成相应撤销后，再取消选拔；若需重新选拔，请先取消当前选拔记录。是否继续？",
          "提示",
          { type: "warning", confirmButtonText: "继续", cancelButtonText: "取消" }
        );
      } catch (e) {
        return;
      }
    }
    // let params = {
    //   ids: this.chooseIdArray,
    //   selectionState: v, //选拔状态 0:取消选拔 1:选拔
    //   subjectId: this.searchForm['subjectId'] //查询条件的科目的id
    // };
    // 修改需求以后的参数
    let type = v;
    let tempArr: Array<object> = [];
    this.chooseRowArray.forEach(v => {
      tempArr.push({
        teacherId: v[`teacherId`],
        selectionState: type, //选拔状态 0:取消选拔 1:选拔
        // selectionState: this.searchForm['chooseStatus'], //选拔状态 0:取消选拔 1:选拔
        subjectId: v[`subjectId`], //查询条件的科目的id
        employState: v[`employState`], // 聘用状态
        projectId: v[`projectId`] //项目id
      });
    });
    try {
      this.fullscreenLoading = true;
      await confirmOrCancelSelect(tempArr);
      this.fullscreenLoading = false;

      // 如果是确认选拔（v === 1），显示快捷跳转对话框
      if (v === 1) {
        this.selectedCount = this.chooseRowArray.length;
        this.showEmployJumpDialog = true;
      } else {
        // 取消选拔直接提示成功
        this.$message.success("操作成功");
      }

      //刷新列表
      this.getData();
    } catch (error) {
      this.fullscreenLoading = false;
      // this.$message.error(error || "操作失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  //排序处理
  private sortChange(v: { column: object; prop: string; order: string }) {
    let { column, prop, order } = v;
    //判断排序字段，获取列表数据
    switch (prop) {
      //工作量（h）
      case "markingWorkload":
        this.orderObj = { orderBy: "orderByMarkingWorkload", order: order };
        this.getData();
        break;
      //无效率(%)
      case "markingInefficiency":
        this.orderObj = { orderBy: "orderByMarkingInefficiency", order: order };
        this.getData();
        break;
      //有效评卷次数
      case "markingEffectiveNum":
        this.orderObj = { orderBy: "orderByMarkingEffectiveNum", order: order };
        this.getData();
        break;
      //平均评卷时间(min)
      case "markingAvgTime":
        this.orderObj = { orderBy: "orderByMarkingAvgTime", order: order };
        this.getData();
        break;
      //评价星级
      case "evaluateStar":
        this.orderObj = { orderBy: "orderByEvaluateStar", order: order };
        this.getData();
        break;
      //优秀教师
      case "otherinfoIsExcellentTeacherValue":
        this.orderObj = { orderBy: "orderByIsExcellentTeacher", order: order };
        this.getData();
        break;
    }
  }

  //点击“配置参数”处理
  private async showParamsDialogHandle() {
    // 之前流程
    // if (!this.searchForm['subjectId']) {
    //   this.$message.warning("请先选择科目！");
    //   return;
    // }
    // 现在流程
    //根据科目id，获取弹窗中的参数值
    // let res = await getSelectParamVo({ subjectId: this.searchForm['subjectId'] });
    // this.paramsForm = res.data;
    this.showParamsDialog = true;
  }

  //配置参数弹窗-保存处理
  private async saveChooseParams() {
    if (!this.paramsForm[`subjectId`]) {
      this.$message.warning("请选择科目！");
      return false;
    }
    this.$refs.editForm.validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.fullscreenLoading = true;
          let res = await editParam(this.paramsForm);
          this.fullscreenLoading = false;
          this.$message.success("保存成功");
          //重置科目 -- 不重置查询条件
          // this.searchForm['subjectId'] = "";
          //关闭弹窗
          this.showParamsDialog = false;
          //刷新列表
          this.getData();
          (this.$refs.editForm as ElForm).clearValidate();
        } catch (error) {
          this.fullscreenLoading = false;
          // this.$message.error(error || "保存失败");
          this[`$message`]({
            type: "error",
            message: error!.mesg ? error!.mesg : error
          });
        }
      }
    });
  }

  private showAutomaticChooseDialog() {
    // 打开自动选拔项目下拉框
    this.showAutoChooeseDialog = true;
  }
  //点击“自动选拔”处理
  private async automaticChoose() {
    if (!this.autoChooeseForm[`projectId`]) {
      this.$message.warning("请先选择项目！");
      return false;
    }
    try {
      this.fullscreenLoading = true;
      let res = await autoSelect(this.autoChooeseForm[`projectId`]);
      this.fullscreenLoading = false;
      this.$message.success("操作成功");
      this.getData();
    } catch (error) {
      this.fullscreenLoading = false;
      // this.$message.error(error || "操作失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  //导出
  private exportHandle() {
    if (!this.searchForm['projectId']) {
      this.$message.warning("请选择项目！");
      return;
    }
    //调用importAndExportMixin中的导出函数
    (this as any).downloadHandle(
      "exportMarkingTeacherChoose",
      "评卷教师选拔.xlsx",
      this.getRequestParams()
    );
  }

  // 每页条目变化时
  private handleSizeChange(val: number): void {
    this.pageSize = val;
    this.getData();
  }

  // 当前页发生改变时
  private handleCurrentChange(val: number): void {
    this.pageNo = val;
    this.getData();
  }

  // 跳转到评卷聘用管理模块
  private jumpToEmployManage() {
    this.showEmployJumpDialog = false;
    // 跳转到评卷聘用管理页面，并传递项目ID作为查询参数
    this.$router.push({
      name: '评卷聘用管理',
      query: {
        projectId: this.searchForm['projectId'],
        projectLabel: this.projectLabel || '',
        fromSelection: 'true' // 标记来自选拔模块
      }
    });
  }

  // 关闭聘用跳转对话框
  private closeEmployJumpDialog() {
    this.showEmployJumpDialog = false;
    this.$message.success("操作成功");
  }
}
